/**
 * Handles display text computation and updating the display DOM for a question (text, select, roommates, date).
 */
export class QuestionDisplayHelper {
  constructor({ questionWrap, display, input, editorElement, isRoommates, placeholder, getRoommatesValue }) {
    this.questionWrap = questionWrap;
    this.display = display;
    this.input = input;
    this.editorElement = editorElement;
    this.isRoommates = isRoommates;
    this.placeholder = placeholder;
    this.getRoommatesValue = getRoommatesValue;
  }

  getDisplayText(rawValue) {
    if (this.isRoommates) {
      const str = typeof rawValue === 'string' ? rawValue : '';
      return str.trim().length ? str : this.placeholder;
    }
    const normalizedValue = rawValue || '';
    if (!normalizedValue.trim().length) {
      return this.placeholder;
    }
    if (this.input.tagName === 'SELECT') {
      const selectedOption = this.input.options[this.input.selectedIndex];
      const selectedText = selectedOption?.textContent?.trim();
      return selectedText && selectedOption.value !== '' ? selectedText : this.placeholder;
    }
    return normalizedValue;
  }

  updateDisplay(rawValue) {
    const displayText = this.getDisplayText(rawValue);
    this.display.textContent = displayText;
    if (displayText === this.placeholder && this.questionWrap.dataset.required === 'true') {
      const badge = document.createElement('span');
      badge.className = 'showing-view-popup__question-badge showing-view-popup__question-badge--required';
      badge.textContent = 'Required';
      this.display.appendChild(badge);
    }
    this.display.classList.toggle('showing-view-popup__question-answer--empty', displayText === this.placeholder);
    if (!this.isRoommates) {
      this.input.value = rawValue || '';
      this.questionWrap.dataset.value = rawValue || '';
    } else {
      this.questionWrap.dataset.value =
        typeof rawValue === 'string' && rawValue.startsWith('{')
          ? rawValue
          : JSON.stringify(this.getRoommatesValue(this.editorElement));
    }
  }
}
